import styled from "styled-components";

export const Container = styled.div `

  display: flex;
  flex-direction: column;
  width: 100%;

  header {
      display: flex;
      justify-content: start;
      margin-bottom: 20px;
  }

  .button-alert-filters-activated {
    max-width: max-content;
    margin: 0 auto;
    padding: 10px 15px;
    border: none;
    color: #fff;
    cursor: pointer;
    border-radius: 50px;
    margin: 5px 0 20px 0;
    font-weight: 600;
    font-size: .8rem;
    background: rgb(211, 0, 0);
    transition: all .3s ease;

    &:hover {
      background:hsl(0, 73.70%, 31.40%) !important;
    }
  }

`

export const SelectContainer = styled.div`

  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-right: 10px;

  label {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }

  select {
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #007bff;
    }

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }

  button {
    padding: 8px;
    font-size: 17px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: unset;
    color: #fff;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #007bff;
    }

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }

  option {
    padding: 8px;
    font-size: 14px;
    color: #333;
  }

`;